import { GroupSeparator } from 'module/types/filter-field/separators';
import type { FilterableField } from 'module/types/filter-field/field/filterable-field';

export const getFieldString = (field: FilterableField) => {
  if (field?.customField && field.userCreated) {
    return `${field?.sourceType}${GroupSeparator}field.${field.fieldId}`;
  }

  return `${field.sourceType}${GroupSeparator}${field.fieldName}`;
};
